import { action, createRequestTypes } from '../base';

export const zohoIntegrationActionTypes = {
  GET_ZOHO_CONNECTIONS: createRequestTypes('GET_ZOHO_CONNECTIONS'),
  UPDATE_ZOHO_CONNECTION: createRequestTypes('UPDATE_ZOHO_CONNECTION'),
  CONNECT_TO_ZOHO: createRequestTypes('CONNECT_TO_ZOHO'),
  CONNECT_TENANT_TO_LOCATION: createRequestTypes('CONNECT_TENANT_TO_LOCATION'),
  SYNC_ZOHO_PRODUCT: createRequestTypes('SYNC_ZOHO_PRODUCT'),
  SYNC_ZOHO_VENDOR: createRequestTypes('SYNC_ZOHO_VENDOR'),
  SYNC_ZOHO_GRN: createRequestTypes('SYNC_ZOHO_GRN'),
  SYNC_ZOHO_PO: createRequestTypes('SYNC_ZOHO_PO'),
  SYNC_ZOHO_DN: createRequestTypes('SYNC_ZOHO_DN'),
  SYNC_ZOHO_INVOICE: createRequestTypes('SYNC_ZOHO_INVOICE'),
  SYNC_ZOHO_CN: createRequestTypes('SYNC_ZOHO_CN'),
  PULL_ZOHO_PRODUCTS: createRequestTypes('PULL_ZOHO_PRODUCTS'),
  PULL_ZOHO_VENDORS: createRequestTypes('PULL_ZOHO_VENDORS'),
  PULL_ZOHO_CUSTOMERS: createRequestTypes('PULL_ZOHO_CUSTOMERS'),
  DELETE_ZOHO_CONNECTION: createRequestTypes('DELETE_ZOHO_CONNECTION'),
  SYNC_DOCUMENT: createRequestTypes('SYNC_DOCUMENT'),
};

/**
 * @param payload
 * @param linkedDaData
 * @param connectToZohoSuccess
 * @param callback
 * @param orgId
 */
class ZohoIntegrationActions {
  getZohoConnections = (orgId, callback) => action(zohoIntegrationActionTypes.GET_ZOHO_CONNECTIONS.REQUEST, {
    orgId, callback,

  })

  /**
   *
   * @param {*} getZohoConnectionsLoading
   * @return
   */
  getZohoConnectionsLoading = (getZohoConnectionsLoading) => action(zohoIntegrationActionTypes.GET_ZOHO_CONNECTIONS.LOADING, {
    getZohoConnectionsLoading,
  })

  /**
   * @return
   * @param linkedDaData
   */
  getZohoConnectionsSuccess = (zohoConnections) => action(zohoIntegrationActionTypes.GET_ZOHO_CONNECTIONS.SUCCESS, {
    zohoConnections,
  })

  /**
    *
    * @param {*} payload
    * @param {*} callback
    * @returns
    */
  updateZohoConnection = (payload, callback) => action(zohoIntegrationActionTypes.UPDATE_ZOHO_CONNECTION.REQUEST, {
    payload, callback,
  })

  /**
  *
  * @param {*} updateZohoConnectionLoading
  * @returns
  */
  updateZohoConnectionLoading = (updateZohoConnectionLoading) => action(zohoIntegrationActionTypes.UPDATE_ZOHO_CONNECTION.LOADING, {
    updateZohoConnectionLoading,
  })

  /**
     * @return
     * @param orgId
     * @param callback
     */
  connectToZoho = (orgId, callback) => action(zohoIntegrationActionTypes.CONNECT_TO_ZOHO.REQUEST, {
    orgId, callback,
  })

  /**
   * @return
   * @param connectToZohoLoading
   */
  connectToZohoLoading = (connectToZohoLoading) => action(zohoIntegrationActionTypes.CONNECT_TO_ZOHO.LOADING, {
    connectToZohoLoading,
  })

  /**
   *
   * @param {*} connectedToZoho
   * @returns
   */
  connectToZohoSuccess = (connectedToZoho) => action(zohoIntegrationActionTypes.CONNECT_TO_ZOHO.SUCCESS, {
    connectedToZoho,
  })

  /**
   * @param iz_id
   * @param callback
   */
  deleteZohoConnection = (payload, callback) => action(zohoIntegrationActionTypes.DELETE_ZOHO_CONNECTION.REQUEST, {
    payload, callback,
  })

  /**
   * @param deleteZohoConnectionLoading
   */
  deleteZohoConnectionLoading = (deleteZohoConnectionLoading) => action(zohoIntegrationActionTypes.DELETE_ZOHO_CONNECTION.LOADING, {
    deleteZohoConnectionLoading,
  })

  /**
   * @param deletedZohoConnection
   */
  deleteZohoConnectionSuccess = (deletedZohoConnection) => action(zohoIntegrationActionTypes.DELETE_ZOHO_CONNECTION.SUCCESS, {
    deletedZohoConnection,
  })

  /**
   * @param {*} payload
   * @param callback
   * @return
   */
  connectTenantToLocation = (payload, callback) => action(zohoIntegrationActionTypes.CONNECT_TENANT_TO_LOCATION.REQUEST, {
    payload, callback,
  })

  /**
  *
  * @param {*} payload
  * @param {*} callback
  * @returns
  */
  syncProduct = (payload, callback) => action(zohoIntegrationActionTypes.SYNC_ZOHO_PRODUCT.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param {*} syncProductLoading
   * @returns
   */
  syncProductLoading = (syncProductLoading) => action(zohoIntegrationActionTypes.SYNC_ZOHO_PRODUCT.LOADING, {
    syncProductLoading,
  })

  /**
   *
   * @param {*} payload
   * @param {*} callback
   * @returns
   */
  syncVendor = (payload, callback) => action(zohoIntegrationActionTypes.SYNC_ZOHO_VENDOR.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param {*} syncVendorLoading
   * @returns
   */
  syncVendorLoading = (syncVendorLoading) => action(zohoIntegrationActionTypes.SYNC_ZOHO_VENDOR.LOADING, {
    syncVendorLoading,
  })

  /**
   *
   * @param {*} payload
   * @param {*} callback
   * @returns
   */
  syncGRN = (payload, callback) => action(zohoIntegrationActionTypes.SYNC_ZOHO_GRN.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param {*} syncGRNLoading
   * @returns
   */
  syncGRNLoading = (syncGRNLoading) => action(zohoIntegrationActionTypes.SYNC_ZOHO_GRN.LOADING, {
    syncGRNLoading,
  })

  /**
   *
   * @param {*} payload
   * @param {*} callback
   * @returns
   */
  syncPO = (payload, callback) => action(zohoIntegrationActionTypes.SYNC_ZOHO_PO.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param {*} syncPOLoading
   * @returns
   */
  syncPOLoading = (syncPOLoading) => action(zohoIntegrationActionTypes.SYNC_ZOHO_PO.LOADING, {
    syncPOLoading,
  })

  /**
   *
   * @param {*} payload
   * @param {*} callback
   * @returns
   */
  syncInvoice = (payload, callback) => action(zohoIntegrationActionTypes.SYNC_ZOHO_INVOICE.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param {*} syncInvoiceLoading
   * @returns
   */
  syncInvoiceLoading = (syncInvoiceLoading) => action(zohoIntegrationActionTypes.SYNC_ZOHO_INVOICE.LOADING, {
    syncInvoiceLoading,
  })

  /**
   *
   * @param {*} payload
   * @param {*} callback
   * @returns
   */
  syncDN = (payload, callback) => action(zohoIntegrationActionTypes.SYNC_ZOHO_DN.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param {*} syncDNLoading
   * @returns
   */
  syncDNLoading = (syncDNLoading) => action(zohoIntegrationActionTypes.SYNC_ZOHO_DN.LOADING, {
    syncDNLoading,
  })

  /**
   *
   * @param {*} payload
   * @param {*} callback
   * @returns
   */
  syncCN = (payload, callback) => action(zohoIntegrationActionTypes.SYNC_ZOHO_CN.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param {*} syncCNLoading
   * @returns
   */
  syncCNLoading = (syncCNLoading) => action(zohoIntegrationActionTypes.SYNC_ZOHO_CN.LOADING, {
    syncCNLoading,
  })

  /**
   *
   * @param {*} payload
   * @param {*} callback
   * @returns
   */
  pullProducts = (payload, callback) => action(zohoIntegrationActionTypes.PULL_ZOHO_PRODUCTS.REQUEST, {
    payload, callback,
  })

  /**
  *
  * @param {*} pullProductsLoading
  * @returns
  */
  pullProductsLoading = (pullProductsLoading) => action(zohoIntegrationActionTypes.PULL_ZOHO_PRODUCTS.LOADING, {
    pullProductsLoading,
  })

  /**
  *
  * @param {*} payload
  * @param {*} callback
  * @returns
  */
  pullVendors = (payload, callback) => action(zohoIntegrationActionTypes.PULL_ZOHO_VENDORS.REQUEST, {
    payload, callback,
  })

  /**
  *
  * @param {*} pullVendorsLoading
  * @returns
  */
  pullVendorsLoading = (pullVendorsLoading) => action(zohoIntegrationActionTypes.PULL_ZOHO_VENDORS.LOADING, {
    pullVendorsLoading,
  })

  /**
  *
  * @param {*} payload
  * @param {*} callback
  * @returns
  */
  pullCustomers = (payload, callback) => action(zohoIntegrationActionTypes.PULL_ZOHO_CUSTOMERS.REQUEST, {
    payload, callback,
  })

  /**
  *
  * @param {*} pullCustomersLoading
  * @returns
  */
  pullCustomersLoading = (pullCustomersLoading) => action(zohoIntegrationActionTypes.PULL_ZOHO_CUSTOMERS.LOADING, {
    pullCustomersLoading,
  })

  /**
   * @return
   * @param connectTenantToLocationLoading
   */
  connectTenantToLocationLoading = (connectTenantToLocationLoading) => action(zohoIntegrationActionTypes.CONNECT_TENANT_TO_LOCATION.LOADING, {
    connectTenantToLocationLoading,
  })

  // zoho automatic document sync
  zohoAutomaticDocumentSync = (payload, callback) => action(zohoIntegrationActionTypes.SYNC_DOCUMENT.REQUEST, {
    payload, callback,
  })

  zohoAutomaticDocumentSyncLoading = (zohoAutomaticDocumentSyncLoading) => action(zohoIntegrationActionTypes.SYNC_DOCUMENT.LOADING, {
    zohoAutomaticDocumentSyncLoading,
  })
}

export default new ZohoIntegrationActions();
